import { Component, OnInit , Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-equilibrar-prepaid',
  templateUrl: './equilibrar-prepaid.component.html',
  styleUrls: ['./equilibrar-prepaid.component.sass']
})
export class EquilibrarPrepaidComponent implements OnInit {
  public selectBan;
  @Input() endDateField;
  @Input() billBalanceField;
  @Input() billBalance;
  @Input() currentList;  
  @Input() subscribers;
  @Input() subscriber;
  @Output() updateinitializeData = new EventEmitter();
  constructor() { }
  ngOnInit() {
    if(sessionStorage.getItem("getAccountDetails")!=null){
      if(JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].prepaidBalanceField!=null){
        this.billBalanceField = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).SubscriberInfo[0].prepaidBalanceField;
        sessionStorage.setItem("prepaidBalance",btoa(this.billBalanceField));
      }
    }
  }
  refreshDataTo(event:Event) {
    let index =parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan",btoa(ban));
    this.updateinitializeData.emit();
  }
}